// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var VerticalPanelColoringTypes;
(function (VerticalPanelColoringTypes) {
    VerticalPanelColoringTypes[VerticalPanelColoringTypes["Default"] = 0] = "Default";
    VerticalPanelColoringTypes[VerticalPanelColoringTypes["LiveLeverage"] = 1] = "LiveLeverage";
})(VerticalPanelColoringTypes || (VerticalPanelColoringTypes = {}));
